import React, { memo } from 'react';

import { useBreadcrumbs } from 'hooks';
import BreadCrumbs from 'components/BreadCrumbs';

export const BanksPageBreadCrumbs = () => {
  const breadcrumbs = useBreadcrumbs();

  return breadcrumbs.length ? <BreadCrumbs breadcrumbs={breadcrumbs} /> : null;
};

export default memo(BanksPageBreadCrumbs);
